import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isSymbol.js
// module id = 293
// module chunks = 8